export default "__VITE_ASSET__8fe0e990__"